import React from 'react';

export function wantToOpenInNewTab(event: React.MouseEvent<HTMLElement>) {
  const which = event.nativeEvent && event.nativeEvent.which;
  return event.metaKey || event.ctrlKey || which === 2;
}

export function wantToOpenInNewTabVanillaEvent(event: MouseEvent) {
  return event.metaKey || event.ctrlKey || event.which === 2;
}
